export default "Variateurs électroniques de vitesse — Fiche CEE IND-UT-114 | Solution Éco France";
